import { useContext, useEffect, useState } from "react"

import { useLocalSearchParams } from "expo-router"

import {
  AccountCollection,
  AccountData,
  ClientCollection,
  DepositoryTransaction,
  DepositoryTransactionCollection,
} from "wealthmode-frontend/backend"
import { formatMoneyFull } from "wealthmode-frontend/util"

import { DetailField, ResourceDetail } from "@/components"
import { BackendContext } from "@/context"

export default function DepositoryTransactionDetail() {
  const { client_id, account_id, depository_transaction_id } = useLocalSearchParams<{
    client_id: string
    account_id: string
    depository_transaction_id: string
  }>()

  const backend = useContext(BackendContext)
  const [transaction, setTransaction] = useState<DepositoryTransaction>()

  useEffect(() => {
    ;(async () => {
      const clients = backend.collection("clients") as ClientCollection
      const client = clients.model(client_id)
      await client.fetch({ reload: true })

      const accounts = client.link("accounts")?.resolve() as AccountCollection
      const account = accounts.model(account_id)
      await account.fetch({ reload: true })

      const data = account.embed("data") as AccountData
      const transactions = data.link("depository_transactions")?.resolve() as
        DepositoryTransactionCollection | undefined
      if (!transactions) {
        return
      }

      const model = transactions.model(depository_transaction_id)
      await model.fetch({ reload: true })

      setTransaction(model)
    })()
  }, [backend, client_id, account_id, depository_transaction_id])

  const fields: DetailField[] = []

  if (transaction) {
    fields.push(
      { label: "Date", value: String(transaction.attributes.date ?? "") },
      { label: "Type", value: transaction.attributes.type ?? "" },
      { label: "Amount", value: formatMoneyFull(transaction.attributes.amount) ?? "" },
    )
  }

  return (
    <ResourceDetail
      title={transaction?.attributes.description || "Depository Transaction"}
      subtitle={depository_transaction_id}
      loading={!transaction}
      fields={fields}
      links={[]}
    />
  )
}
